import { formatISODate } from "../../../../../../../../../../shared/utils/formateDate";
import { ChatItem } from "../chat-item/ChatItem";
import { ChatItemDraft } from "../chat-item-draft/ChatItemDraft";
import type { HistoryConversation } from "../../utils/build-history-conversations";
import { isBumblebeeSession } from "../../../../../../../../../../shared/utils/bumblebeeSession";
import { SESSION_TYPE_BUMBLEBEE_STATUS } from "../../../../../../../../../../shared/types/bumblebee.type";
import type { SessionType } from "../../../../../../../../../../shared/types/session.type";

interface Props {
	items: HistoryConversation[];
	sessionId: string | null;
	activeDraftId: string | null;
	onSetSessionId: (sessionId: string, chatKind?: SessionType) => void;
}

export const HistoryConversationList = ({
	items,
	sessionId,
	activeDraftId,
	onSetSessionId,
}: Props) => (
	<>
		{items.map((item) => {
			if (item.kind === "session") {
				const s = item.session;
				const chatKind: SessionType = isBumblebeeSession(s)
					? SESSION_TYPE_BUMBLEBEE_STATUS
					: "assistant";
				return (
					<ChatItem
						key={`session-${s.session_id}`}
						title={s.title ? s.title : ""}
						date={formatISODate(s.created_at)}
						updateDate={formatISODate(s.updated_at)}
						isActive={s.session_id === sessionId}
						sessionId={s.session_id}
						canDelete={s.can_delete !== false}
						isBumblebee={isBumblebeeSession(s)}
						hasUnread={Boolean(s.has_unread)}
						unreadCount={s.unread_count ?? 0}
						campaignId={s.campaign_id}
						onSetSessionId={(id) => onSetSessionId(id, chatKind)}
					/>
				);
			}
			return (
				<ChatItemDraft
					key={`draft-${item.draft.draft_id}`}
					draft={item.draft}
					updateDate={formatISODate(item.draft.updated_at)}
					isActive={
						sessionId === null && activeDraftId === item.draft.draft_id
					}
				/>
			);
		})}
	</>
);
